export enum UserClaims {
  ViewUser = 'ViewUser',
  InviteNewUser = 'InviteNewUser',
  ChangeUserStatus = 'ChangeUserStatus',
  ReopenUserProfile = 'ReopenUserProfile',
  ResetPassword = 'ResetPassword',
  CloneUser = 'CloneUser',
  EditUser = 'EditUser',
  AccountSearch = 'AccountSearch',
  TransactionSearch = 'TransactionSearch',
  Disputes = 'Disputes',
  Programs = 'Programs',
  UpdateCardPackage = 'UpdateCardPackage',
  FundsRecoveryAdmin = "FundsRecoveryAdmin",
  FundsRecoveryViewer = "FundsRecoveryViewer",
  NegativeBalanceSummaryViewer = "NegativeBalanceSummaryViewer",

  //Special Claim for Dashboard KPI
  DashboardKPI = 'KPI',

  //Dashboard KPI Claims
  EnrollmentsKPI = 'EnrollmentsKPI',
  DailySettlementKPI = 'DailySettlementKPI',
  LoadsbyFundingKPI = 'LoadsbyFundingKPI',
  GamingTransfersKPI = 'GamingTransfersKPI',
  SevenDayCardUsageKPI = '7DayCardUsageKPI',
  DisputesKPI = 'DisputesKPI',
  VIPUpgradesKPI = 'VIPUpgradesKPI',

  //Reports
  PostedSettlementRecon = 'PostedSettlementRecon',
  VIPUpgrades = 'VIPUpgrades',
  DepositFunnel = 'DepositFunnel',
  FundingAnalysis = 'FundingAnalysis',
  EnrollmentDetails = 'EnrollmentDetails',
  DisputeHistory = 'DisputeHistory',

  //Internal User
  InviteInternalUser = 'InviteInternalUser',
  CloneInternalUser = 'CloneInternalUser',
  EditInternalUser = 'EditInternalUser',
  ViewInternalUser = 'ViewInternalUser',
  ViewOrg = 'ViewOrg',
  AddOrg = 'AddOrg',
  EditOrg = 'EditOrg',
  UpdateCardArt = 'UpdateCardArt',
}

export const ReportClaims = [
  UserClaims.PostedSettlementRecon,
  UserClaims.VIPUpgrades,
  UserClaims.DepositFunnel,
  UserClaims.FundingAnalysis,
  UserClaims.EnrollmentDetails,
  UserClaims.DisputeHistory
]

export const DownloadReportClaims = [
  UserClaims.PostedSettlementRecon,
  UserClaims.VIPUpgrades
]

export enum ProgramType {
  Unknown = 'Unknown',
  PlayPlus = 'PlayPlus',
  CrbModel1WithoutFunding = 'CrbModel1WithoutFunding',
  CrbModel1WithFunding = 'CrbModel1WithFunding',
  CrbModel2 = 'CrbModel2'
}

export enum DashboardGroupSection {
  PlayPlus = 'PlayPlus',
  EmbeddedBanking = 'EmbeddedBanking'
}

export class ProgramTypeKPI {
  programType: ProgramType | DashboardGroupSection
  kpiClaims: UserClaims[]
}

export const dashboardGroupSectionKPI: ProgramTypeKPI[] = [
  {
    programType: DashboardGroupSection.PlayPlus,
    kpiClaims:
      [
        UserClaims.EnrollmentsKPI,
        UserClaims.DailySettlementKPI,
        UserClaims.LoadsbyFundingKPI,
        UserClaims.GamingTransfersKPI,
        UserClaims.SevenDayCardUsageKPI,
        UserClaims.DisputesKPI,
        UserClaims.VIPUpgradesKPI
      ]
  },
  {
    programType: DashboardGroupSection.EmbeddedBanking,
    kpiClaims: [
      UserClaims.EnrollmentsKPI,
      UserClaims.DailySettlementKPI,
      UserClaims.LoadsbyFundingKPI,
      UserClaims.GamingTransfersKPI,
      UserClaims.SevenDayCardUsageKPI,
      UserClaims.DisputesKPI
    ]
  }
]

export const programTypeKPIs: ProgramTypeKPI[] = [
  {
    programType: ProgramType.PlayPlus,
    kpiClaims:
      [
        UserClaims.EnrollmentsKPI,
        UserClaims.DailySettlementKPI,
        UserClaims.LoadsbyFundingKPI,
        UserClaims.GamingTransfersKPI,
        UserClaims.SevenDayCardUsageKPI,
        UserClaims.DisputesKPI,
        UserClaims.VIPUpgradesKPI
      ]
  },
  {
    programType: ProgramType.CrbModel1WithoutFunding,
    kpiClaims: [
      UserClaims.EnrollmentsKPI,
      UserClaims.DailySettlementKPI,
      UserClaims.GamingTransfersKPI,
      UserClaims.SevenDayCardUsageKPI
    ]
  },
  {
    programType: ProgramType.CrbModel1WithFunding,
    kpiClaims: [
      UserClaims.EnrollmentsKPI,
      UserClaims.DailySettlementKPI,
      UserClaims.LoadsbyFundingKPI,
      UserClaims.GamingTransfersKPI,
      UserClaims.SevenDayCardUsageKPI,
      UserClaims.DisputesKPI
    ]
  },
  {
    programType: ProgramType.CrbModel2,
    kpiClaims: [
      UserClaims.EnrollmentsKPI,
      UserClaims.DailySettlementKPI,
      UserClaims.SevenDayCardUsageKPI
    ]
  }
]